/**
 * @file     vowTerms.ts
 * @readme   ./CLAUDE.md
 * @purpose  The version stamp for the VOW Terms of Use. Rule 9.06(d) requires
 *           proving a registrant expressly agreed to the terms, which means
 *           knowing WHICH text they agreed to. Bump this whenever
 *           VowDataTermsContent changes in substance.
 */

/** Date-stamped so the accepted text is recoverable from Git history. */
export const VOW_TOU_VERSION = '2026-08-07';
